import { useState, useEffect } from 'react';
import { ActivityIndicator, SafeAreaView, View, Text, VirtualizedList, StyleSheet, Pressable, FlatList, Image } from 'react-native';
import { Provider, Button, Searchbar, Divider, Avatar } from 'react-native-paper';
import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';
import Global from '../constants/global';
import DYear from '../components/DYear';
import { collection, doc, getDocs, getFirestore, onSnapshot, query, where } from 'firebase/firestore';

const backupDate = dayjs().unix()
const backupDay = dayjs().format("DDMMMYYYY") // Output: "12Oct2025"

export default function Backup({ route, navigation }) {
    // const users = useSelector((state) => state.list.Users)
    // const std = useSelector((state) => state.list.Students)
    // const sch = useSelector((state) => state.list.ExamScheme)
    // const arr = useSelector((state) => state.list.Arrangement)
    // const posts = useSelector((state) => state.list.Posts)
    // const subjects = useSelector((state) => state.list.Posts)
    // const marks = useSelector((state) => state.list.Marks)
    // const exams = useSelector((state) => state.list.Exams)
    // const leaves = useSelector((state) => state.list.Leaves)
    // const stvm = useSelector((state) => state.list.stvm)
    // const noti = useSelector((state) => state.list.Notifications)
    // const donations = useSelector((state) => state.list.Donations)
    // const examScheme = useSelector((state) => state.list.ExamScheme)
    const [data, setData] = useState({ Users: [], Students: [], Arrangement: [], ExamScheme: [], Posts: [], Exams: [], Marks: [], Subjects: [], Leaves: [], stvm: [], Notifications: [], Donations: [], PresentDays: [], MedicalMarks: [], ResultReport: [] });
    const [show, setShow] = useState(false);
    const [year, setYear] = useState(Global.getYear());


    return (
        <SafeAreaView style={{ backgroundColor: "white", flex: 1 }}>
            <View style={{ flexDirection: "row", alignItems: "center", padding: 10 }}>
                <Text>Select Year : </Text>
                <Button mode='outlined' onPress={() => { setShow(true) }}>{year}</Button>
            </View>
            <Dump list={Global.USERS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={Global.EXAMSCHEME} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={Global.POSTS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={Global.LEAVES} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={"stvm"} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={Global.NOTIFICATIONS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <Dump list={Global.DONATIONS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} />
            <SelectiveDump list={Global.ARRANGEMENT} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />
            <SelectiveDump list={Global.PRESENTDAYS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />
            <SelectiveDump list={Global.RESULTREPORT} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />
            <SelectiveDump list={Global.MEDICALMARKS} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />
            <SelectiveDumpQuery list={Global.MARKS} data={data.Marks} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />
            <GetAllStudents list={Global.STUDENTS} data={data.Students} update={(name, list) => setData(p => ({ ...p, [name]: list }))} year={year} />

            

            <DYear show={show} text={"Select Year"} year={year} close={() => {
                setShow(false)
            }} change={(yr) => {
                setYear(yr)
                setShow(false)
            }} />
            <Generate data={data} />
        </SafeAreaView>
    );

}

const Generate = (data) => {
    const [fileName, setFileName] = useState("");
    const [str, setStr] = useState("");

    useEffect(() => {
        let d = {}
        d = { ...data }
        d.backupDate = backupDate
        d.backupDay = backupDay
        let t = JSON.stringify(d)
        setStr(t)
        setFileName(backupDay + ".bkp")
    }, [data])
    {

        return <a download={fileName} href={
            URL.createObjectURL(new Blob([str],
                { type: 'text/plain;charset=utf-8' }))}>Download  (File Name = {fileName},   {str.length ? "approx Size = "+(str.length / 1000) + " kb" : ""})</a>
    }

}
const Dump = ({ list, update }) => {

    const l = useSelector((state) => state.list[list])
    useEffect(() => {
        update(list, l)
    }, [l])
    return <View style={{ flexDirection: "row", }}>
        <Text style={{ width: 150 }}>{list}</Text>
        <Text style={{}}> : {list?.length}</Text>

    </View>
}

const SelectiveDump = ({ list, update, year }) => {
    const [loading, setLoging] = useState(true);
    const [d, setD] = useState([]);
    async function getList() {
        setLoging(true)
        const Result = await getReports(list, year)
        update(list, Result)
        setD(Result)
        setLoging(false)
    }
    useEffect(() => {
        getList()
    }, [year])
    return <View style={{ flexDirection: "row", }}>
        <Text style={{ width: 150 }}>{list}</Text>
        <Text style={{}}> : {d?.length}</Text>
        {loading && <ActivityIndicator animating />}
    </View>
}

const SelectiveDumpQuery = ({ list, data, update, year }) => {
    const [loading, setLoging] = useState(true);
    const [d, setD] = useState([]);

    useEffect(() => {
        setLoging(true)
        const citiesRef = collection(getFirestore(), Global.MARKS);
        let q = query(citiesRef, where("year", "==", year));
        const s = onSnapshot(q, { includeMetadataChanges: true },
            (docc) => {
                const tklist = []

                docc.docChanges().forEach((change) => {
                    tklist.push(change.doc.data())
                })
                if (tklist.length) {
                    data?.map(mk => tklist.push(mk))
                    update(list, tklist)
                    setD(tklist)
                }
                setLoging(false)
            })
        return () => s()
    }, [year])

    return <View style={{ flexDirection: "row", }}>
        <Text style={{ width: 150 }}>{list}</Text>
        <Text style={{}}> : {d?.length}</Text>
        {loading && <ActivityIndicator animating />}
    </View>
}

const getReports = async (list, year) => {
    const snapshot = await getDocs(collection(getFirestore(), list));
    const filteredDocs = snapshot.docs.filter(doc => doc.id.includes(year + ""));
    let Result = []
    filteredDocs.map(d => {
        Result.push({ id: d.id, data: d.data() })
    })
    return Result
};


const GetAllStudents = ({ list, data, update, year }) => {
    const [loading, setLoging] = useState(true);
    const [d, setD] = useState([]);

    useEffect(() => {
        setLoging(true)
        const citiesRef = collection(getFirestore(), Global.STUDENTS);
        let q = query(citiesRef, where('class'+year, '!=', null));
          
        const s = onSnapshot(q, { includeMetadataChanges: true },
            (docc) => {
                const tklist = []

                docc.docChanges().forEach((change) => {
                    tklist.push(change.doc.data())
                })
                if (tklist.length) {
                    data?.map(mk => tklist.push(mk))
                    update(list, tklist)
                    setD(tklist)
                }
                setLoging(false)
            })
        return () => s()
    }, [year])

    return <View style={{ flexDirection: "row", }}>
        <Text style={{ width: 150 }}>{list}</Text>
        <Text style={{}}> : {d?.length}</Text>
        {loading && <ActivityIndicator animating />}
    </View>
}

